"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const decorators_1 = require("@powerednow/shared/modules/utilities/decorators");
const constants_1 = require("@powerednow/shared/constants");
const date_1 = require("@powerednow/shared/modules/utilities/date");
const array_1 = __importDefault(require("@powerednow/shared/modules/utilities/array"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const bluebird_1 = __importDefault(require("bluebird"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
const _ = require('lodash');
// eslint-disable-next-line no-redeclare
class User extends complexData_1.default {
    static get allowedAssociations() {
        return {
            company: {
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                key: 'company',
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getFieldSymbols().company_id,
                },
            },
            userUserProfile: {
                key: 'useruserprofile',
                instance: (0, modelLookup_1.complexFindModel)('UserUserProfile'),
                cascadeDelete: true,
                condition: {
                    user_id: this.Entity.getFieldSymbols().id,
                },
            },
            signature: {
                key: 'signature',
                instance: (0, modelLookup_1.complexFindModel)('Signature'),
                single: true,
                cascadeDelete: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().signature_id,
                },
            },
            userToAddress: {
                key: 'userToAddress',
                instance: (0, modelLookup_1.complexFindModel)('UserToAddress'),
                cascadeDelete: true,
                condition: {
                    user_id: this.Entity.getFieldSymbols().id,
                },
            },
            userMedia: {
                key: 'userMedia',
                instance: (0, modelLookup_1.complexFindModel)('UserMedia'),
                cascadeDelete: true,
                condition: {
                    user_id: this.Entity.getFieldSymbols().id,
                },
            },
            userProfilePicture: {
                key: 'userMedia',
                instance: (0, modelLookup_1.complexFindModel)('UserMedia'),
                single: true,
                condition: {
                    user_id: this.Entity.getFieldSymbols().id,
                    type: constants_1.USER.MEDIA_TYPES.PROFILE_PICTURE,
                },
            },
            userMediaQualifications: {
                key: 'userMedia',
                instance: (0, modelLookup_1.complexFindModel)('UserMedia'),
                condition: {
                    user_id: this.Entity.getFieldSymbols().id,
                    type: constants_1.USER.MEDIA_TYPES.QUALIFICATIONS,
                },
            },
            userSettings: {
                key: 'userSettings',
                instance: (0, modelLookup_1.complexFindModel)('UserSettings'),
                cascadeDelete: false,
            },
        };
    }
    get fieldChangeEventHandlers() {
        return {
            email: () => {
                this.data.is_valid = false;
            },
        };
    }
    getAllContactMethod() {
        const methods = [
            new ((0, modelLookup_1.complexFindModel)('ContactMethod'))({
                value: this.data.email,
                contactmethodtype_id: constants_1.MESSAGES.TYPES.EMAIL,
            }),
        ];
        return methods;
    }
    async getUserProfiles() {
        const userUserProfiles = await this.getAllUserUserProfile();
        const companyComplex = await this.getCompany();
        const roles = await companyComplex.findRoles();
        return bluebird_1.default.map(userUserProfiles, async (userUserProfile) => {
            const userProfile = await userUserProfile.getUserProfile();
            const userProfileRoles = roles.filter(role => role.data.userprofile_id === userProfile.data.id);
            const roleIds = userProfileRoles.map(userProfileRole => userProfileRole.data.role_id);
            userProfile.roles = roleIds;
            return userProfile;
        });
    }
    async getExternallyUsableUserUserProfiles() {
        const userUserProfiles = await this.getAllUserUserProfile();
        return bluebird_1.default.filter(userUserProfiles, async (userUserProfile) => {
            const userProfile = await userUserProfile.getUserProfile();
            return !userProfile?.data.internal;
        });
    }
    async setProfile(userProfileId) {
        const userUserProfile = await this.getExternallyUsableUserUserProfiles();
        if (userUserProfile.length === 0) {
            return this.addUserUserProfile({
                user_id: this.data.id,
                userprofile_id: userProfileId,
            });
        }
        if (userUserProfile.length > 1) {
            throw new Error('This code does not support n:m relation yet!');
        }
        userUserProfile[0].data.userprofile_id = userProfileId;
        return userUserProfile[0];
    }
    async isMainUser() {
        const userProfiles = await this.getUserProfiles();
        return userProfiles.some(userProfile => userProfile.data.id === constants_1.USER_PROFILE.MAIN_USER);
    }
    async hasRole(roleId) {
        const userUserProfiles = await this.getAllUserUserProfile();
        let result = false;
        await bluebird_1.default.each(userUserProfiles, async (userUserProfile) => {
            const roles = await this.findAllUserRoles(roleId, userUserProfile.data.userprofile_id);
            if (roles && roles.length > 0) {
                result = true;
            }
        });
        return result;
    }
    /**
     * Get the user's full name (firstname + lastname)
     * @returns {string}
     */
    getFullName() {
        // You can use this to get the user's full name (firstname + lastname)
        let fullName = '';
        if (this.data.firstname) {
            fullName += this.data.firstname;
        }
        if (this.data.lastname) {
            if (this.data.firstname) {
                // add space between firstname and lastname
                fullName += ' ';
            }
            fullName += this.data.lastname;
        }
        return fullName;
    }
    async getJobTitle() {
        return (await this.getSettingValue(constants_1.SETTINGS_KEYS.SERVICE_PERSON));
    }
    async getPhoneNumber() {
        return (await this.getSettingValue(constants_1.SETTINGS_KEYS.PHONE_NUMBER));
    }
    async getCompanyPhoneNumber() {
        const company = await this.getCompany();
        return company.getPhone();
    }
    async getAssigneeDetails() {
        const jobTitle = await this.getJobTitle();
        const jobTitleText = jobTitle ? `(${jobTitle})` : '';
        const fullName = this.getFullName();
        return `${fullName} ${jobTitleText}`.trim();
    }
    /**
     * Get user and associated data to be used in setData calls to display user info
     *
     * @returns {any}
     */
    async getRelated() {
        const data = _.cloneDeep(this.data.getPureDataValues());
        data.fullName = this.getFullName();
        //
        // Add role data
        //
        const userUserProfiles = await this.getAllUserUserProfile();
        const userProfiles = await bluebird_1.default.map(userUserProfiles, userUserProfile => userUserProfile.getUserProfile());
        const nonInternalProfiles = userProfiles.filter(profile => !profile.data.internal);
        if (nonInternalProfiles.length > 0) {
            data.role = { ...nonInternalProfiles[0].data.getPureDataValues() };
        }
        //
        // Add signature URL
        //
        const signature = await this.getSignature();
        if (signature) {
            data.signatureUrl = signature.data.url;
        }
        return data;
    }
    async findAddress() {
        let [userToAddress] = await this.getAllUserToAddress();
        if (!userToAddress) {
            const ComplexConstructor = (0, modelLookup_1.complexFindModel)('UserToAddress');
            userToAddress = new ComplexConstructor({ user_id: this.data.id });
            await this.addUserToAddress(userToAddress);
            const address = new ((0, modelLookup_1.complexFindModel)('Address'))({});
            await userToAddress.setAddress(address);
        }
        return userToAddress.getAddress();
    }
    async setSettingValue(settingId, value) {
        let setting = await this.findUserSetting(settingId);
        if (!setting) {
            setting = await this.addUserSettings({
                setting_key_id: settingId,
                setting_value: value,
                user_id: this.data.id,
            });
        }
        else {
            setting.data.setting_value = value;
        }
        return setting;
    }
    async getSettingValue(settingId) {
        const setting = await this.findUserSetting(settingId);
        if (!setting) {
            const defaultValue = await (0, modelLookup_1.complexFindModel)('SettingsKeys').getDefaultSettingValue(settingId, this);
            await this.setSettingValue(settingId, defaultValue);
            return defaultValue;
        }
        return setting.data.setting_value;
    }
    async getColorCode() {
        let color = await this.getSettingValue(constants_1.SETTINGS_KEYS.USER_COLOR);
        if (!color) {
            color = await this.getLegacyColor();
        }
        return `${(color[0] === '#' ? '' : '#')}${color}`;
    }
    async getLegacyColor() {
        const legacyUserColors = constants_1.USER.LEGACY_COLORS;
        const usersRequest = await this.loadGenericData(User);
        const users = usersRequest && usersRequest.responseData;
        let userIndex = users.findIndex(user => user.id === this.data.id);
        if (userIndex < 0) {
            userIndex = users.length - 1;
        }
        return legacyUserColors[userIndex % Object.keys(legacyUserColors).length];
    }
    async findAllUserRoles(roleId, userProfileId) {
        const companyComplex = await this.getCompany();
        const roles = await companyComplex.findRoles();
        return roles.filter(role => (role.data.role_id === roleId && role.data.userprofile_id === userProfileId));
    }
    async findUserSetting(settingId) {
        const settings = await this.getAllUserSettings();
        return settings.find((settingsItem) => {
            const sameKey = settingsItem.data.setting_key_id === settingId;
            const sameUser = settingsItem.data.user_id === this.data.id;
            return sameKey && sameUser;
        });
    }
    async getAvailabilityForAppointments() {
        const settingValue = await this.getSettingValue(constants_1.SETTINGS_KEYS.AVAILABILITY_APPOINTMENTS);
        try {
            return JSON.parse(settingValue);
        }
        catch (e) {
            return {};
        }
    }
    async getAvailableDays() {
        const availabilityForAppointments = await this.getAvailabilityForAppointments();
        return date_1.DAY_NAMES.filter(dayName => availabilityForAppointments[dayName].enabled);
    }
    async getUnavailableDays() {
        const availabilityForAppointments = await this.getAvailabilityForAppointments();
        return date_1.DAY_NAMES.filter(dayName => !availabilityForAppointments[dayName].enabled);
    }
    async getDataForUnavailabilityWarning(startDate, endDate) {
        return {
            fullName: this.getFullName(),
            unavailableDates: await this.getUnavailableDates(startDate, endDate),
        };
    }
    async isAvailable(startDate, endDate) {
        const availableDays = await this.getAvailableDays();
        const daysToBook = (0, date_1.getDayNamesBetweenDates)(startDate, endDate);
        return array_1.default.areAllElementsIncluded(availableDays, daysToBook);
    }
    async getUnavailableDates(startDate, endDate) {
        const unavailableDays = await this.getUnavailableDays();
        return (0, date_1.getUnavailableDatesBetweenDates)(startDate, endDate, unavailableDays);
    }
    async getExpenseInitialStatus() {
        const userProfiles = await this.getAllUserUserProfile();
        const userProfile = userProfiles[0];
        const company = await this.getCompany();
        const { expenseInitialStatus } = company.data;
        const profileStatusMap = {
            [constants_1.USER_PROFILE.MAIN_USER]: expenseInitialStatus.main_users,
            [constants_1.USER_PROFILE.MANAGER]: expenseInitialStatus.managers,
            [constants_1.USER_PROFILE.ENGINEER]: expenseInitialStatus.engineers,
        };
        return profileStatusMap[userProfile.data.id];
    }
    async getNewDocumentStatus() {
        let docStatus;
        const company = await this.getCompany();
        const subscriptionInfo = await company.getSubscriptionInfo();
        const expenseInitialStatus = await this.getExpenseInitialStatus();
        if (expenseInitialStatus && subscriptionInfo.purchaseSetup.canApproveDoc) {
            docStatus = expenseInitialStatus.status;
        }
        else {
            docStatus = constants_1.DOCUMENT.STATUS.ACCEPTED;
        }
        if (docStatus === constants_1.DOCUMENT.STATUS.PAID) {
            docStatus = constants_1.DOCUMENT.STATUS.RAISED;
        }
        return docStatus;
    }
    async getExpenseInitialPaymentId() {
        const expenseInitialStatus = await this.getExpenseInitialStatus();
        return (expenseInitialStatus.paymentType === 0 || expenseInitialStatus.paymentType === '0') ? null : expenseInitialStatus.paymentType;
    }
}
User.Entity = entity_1.default;
User.modelProperties = modelProperties_1.default;
__decorate([
    decorators_1.memoizeRunningPromise
], User.prototype, "findAddress", null);
exports.default = User;
//# sourceMappingURL=../../../../src/models/user/index.js.map